'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trustMetricsSelector = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _about = require('./about');

var _home = require('./home');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reducer
var DEFAULT_STATE = {
    trustMetrics: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _about.LOAD_ABOUT_DATA_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
            return (0, _extends3.default)({}, state, {
                trustMetrics: (0, _extends3.default)({}, action.payload.siteStatistics)
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.trustMetrics;
};

var trustMetricsSelector = exports.trustMetricsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.trustMetrics;
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/trustMetrics.js
// module id = v7MT
// module chunks = 60